import { SESSION_STATUS } from '@/constants/auth';
import { useEffect, useRef } from 'react';
import { useSession } from 'next-auth/react';
import { createApiClients } from '@/lib/createApiClients';
import { PrivateContextData } from '@/components/private/PrivateContext';
import { RoleUserOrgAssociationDto } from '@/apiClient';

export function useInitializeContext(
  selectedOrganisationId?: number,
  userOrganisations?: PrivateContextData['userOrganisations'],
  setContextData?: (
    data:
      | PrivateContextData
      | ((prev: PrivateContextData) => PrivateContextData),
  ) => void,
  setUserOrganisations?: (orgs: RoleUserOrgAssociationDto[]) => void,
  setSelectedOrganisationId?: (id: number) => void,
) {
  const { data: session, status } = useSession();
  const hasInitializedRef = useRef(false);

  useEffect(() => {
    if (!setContextData) return;
    if (status !== SESSION_STATUS.AUTHENTICATED || !session?.user) return;
    if (hasInitializedRef.current) return;

    hasInitializedRef.current = true;

    const { axiosInstance, userApi, userProfileApi, ...apiClients } =
      createApiClients();

    setContextData({
      axiosInstance,
      userId: session.user.internalUserId,
      userGuid: session.user.userGuid,
      userEmail: session.user.email ?? undefined,
      loginFlowComplete: true,
      userApi,
      userProfileApi,
      selectedOrganisationId,
      setSelectedOrganisationId,
      setUserOrganisations,
      userOrganisations,
      ...apiClients,
    });
  }, [
    session,
    status,
    selectedOrganisationId,
    userOrganisations,
    setContextData,
    setUserOrganisations,
    setSelectedOrganisationId,
  ]);
}
